export default __webpack_public_path__ + "static/media/new.1b27c648.svg";